import { IActionType, SET_SELECTED_TEMPLATE, SET_SELECTED_URL, SET_CREATED_URL } from "../actions/receiveMessage.action"
import { IReceiveMessageState } from "../models/root.interface";

const initialState: IReceiveMessageState = {
    selectedTemplateId: "",
    selectedUrlId: "",
    createdUrl: ""
}

const receiveMessageReducer = (state: IReceiveMessageState = initialState, action: IActionType): IReceiveMessageState => {
    switch (action.type) {
        case SET_SELECTED_TEMPLATE:
            return {
                ...state,
                selectedTemplateId: action.payload
            }
        case SET_SELECTED_URL:
            return {
                ...state,
                selectedUrlId: action.payload
            }
        case SET_CREATED_URL:
            return {
                ...state,
                createdUrl: action.payload
            }
        default:
            return state;
    }
}

export default receiveMessageReducer;